module.exports = __webpack_public_path__ + "img/kongres2.2ca8cd1a.jpg";